'use client';

import { c as _c } from "react/compiler-runtime";
import { useIdentityContext } from '@cc-shopping/platform-analytics/IdentityContext';
import { Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import type { Odds } from '.';
import type { ApprovalOddsButtonProps } from './ApprovalOddsButton';
import { ApprovalOddsLikelihoodContent } from './ApprovalOddsLikelihoodContent';
import { DefaultApprovalOddsTextContentTypographyProps, getDefaultApprovalOddsTextContentDriver } from './ApprovalOddsTextContent';
export const useApprovalOddsLikelihood = (analytics, odds, isAmexOffer, approvalLikelihood) => {
  const $ = _c(16);
  const {
    identity,
    isLoading,
    isRefetching
  } = useIdentityContext();
  const [userCreditScore, setUserCreditScore] = useState();
  let t0;
  let t1;
  if ($[0] !== identity) {
    t0 = () => {
      if (identity && identity.creditScore) {
        setUserCreditScore(identity.creditScore / 850);
      }
    };
    t1 = [identity];
    $[0] = identity;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (isLoading || isRefetching) {
    const t2 = isAmexOffer ? "Recommended credit" : "Recommended credit score";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Skeleton height={50} width="75%" />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2) {
      t4 = {
        label: t2,
        value: t3
      };
      $[4] = t2;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  if (!approvalLikelihood) {
    let t2;
    if ($[6] !== analytics || $[7] !== isAmexOffer || $[8] !== odds || $[9] !== userCreditScore) {
      t2 = getDefaultApprovalOddsTextContentDriver({
        firePageActionOnClick: true,
        analytics,
        isAmexOffer,
        userCreditScore,
        odds,
        showBCCVariant: true
      });
      $[6] = analytics;
      $[7] = isAmexOffer;
      $[8] = odds;
      $[9] = userCreditScore;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    return t2;
  }
  let t2;
  if ($[11] !== approvalLikelihood || $[12] !== isAmexOffer || $[13] !== odds || $[14] !== userCreditScore) {
    t2 = {
      label: "Your approval odds",
      value: <ApprovalOddsLikelihoodContent userCreditScore={userCreditScore} odds={odds} approvalLikelihood={approvalLikelihood} isAmexOffer={isAmexOffer} typographyProps={DefaultApprovalOddsTextContentTypographyProps} />
    };
    $[11] = approvalLikelihood;
    $[12] = isAmexOffer;
    $[13] = odds;
    $[14] = userCreditScore;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
};